import get from 'lodash/get';

const addLearnosityPerformance = (learnosityServerData) => {
  const qInitOptions = get(
    learnosityServerData,
    'questions_api_init_options',
    {},
  );

  qInitOptions.render_optimization = {
    defer_render: true,
  };

  learnosityServerData.questions_api_init_options = {
    ...qInitOptions,
  };

  return learnosityServerData;
};

export default addLearnosityPerformance;
